"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const setToArray_1 = __importDefault(require("./setToArray"));
/** Used as references for various `Number` constants. */
const INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
const createSet = (Set && (1 / (0, setToArray_1.default)(new Set([, -0]))[1]) == INFINITY)
    ? (values) => new Set(values)
    : () => { };
exports.default = createSet;
